import axios from "axios";
import { creatorDefaultImages, node_server } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { setIsButtonLoading } from "../../store/slices/loadingSlice";
import {
  setUser,
  setUserSkills,
  setCommunityStatus as setUserStatus,
} from "../../store/slices/userSlice";
import moment from "moment";
import checkSkillComplete from "../../helpers/checkSkillComplete";
import { checkPrimarySkill } from "../../helpers/checkPrimarySkill";
import checkProfileComplete from "../../helpers/checkProfileComplete";
import generateFeeds from "../../helpers/generateFeeds";
import { setPage } from "../../store/slices/profile/discoverSlice";
import { useNavigate } from "react-router-dom";
import useSettings from "../useSettings";
import { updateInvalid } from "../../store/slices/infoSlice";

const useEditSkill = () => {
  const { data } = useSelector((state) => state.skill);
  const {
    value: user,
    activeUserSkill,
    status: userStatus,
    collaboratorsTypes,
  } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { recalculateScore } = useSettings();

  const getStartedTrainingDate = () => {
    return user?.birthDate
      ? moment(user?.birthDate)
          .add(data?.startedTrainingAge || 10, "years")
          .format("YYYY-MM-DD")
      : null;
  };

  const editSkill = async () => {
    dispatch(setIsButtonLoading(true));

    if (data?.startedTrainingAge && data?.startedTrainingAge < 10) {
      dispatch(
        updateInvalid({
          isInvalidOpen: true,
          message: "The started training age must be at least 10 years old.",
        })
      );
      dispatch(setIsButtonLoading(false));
      return;
    }

    const startedTrainingDate = getStartedTrainingDate();

    let original = activeUserSkill.originalCoverImage.split(".com")[1];
    let cropp = activeUserSkill.skillCoverImage.split(".com")[1];
    const exists = Object.values(creatorDefaultImages).includes(original);
    if (exists || original === null) {
      const targetCreatorType = data?.category;
      const targetImage = creatorDefaultImages[targetCreatorType];
      original = targetImage;
      cropp = targetImage;
    }

    const isSkillComplete = checkSkillComplete({
      name: data?.name,
      description: data?.description,
      level: data?.level,
      startedTrainingDate,
    });

    const { data: returnedData, error } = await axios.post(
      `${node_server}/api/skills/update`,
      {
        name: data?.name,
        level: data?.level,
        startedTrainingAge: data?.startedTrainingAge,
        startedTrainingDate,
        category: data?.category,
        speciality: data?.speciality,
        link: data?.link,
        description: data?.description,
        isPrimary: data?.isPrimary,
        acceptOnlyPaidProject: data?.acceptOnlyPaidProject,
        isCompleted: isSkillComplete,
        skillCoverImage: cropp,
        originalCoverImage: original,
      },
      {
        params: { id: data?.id },
        withCredentials: true,
      }
    );

    if (error) console.log(error);
    if (returnedData) {
      if (returnedData.message) {
        dispatch(setIsButtonLoading(false));
        dispatch(
          updateInvalid({
            isInvalidOpen: true,
            message: "You are not permitted to update this skill !",
          })
        );
        return;
      }
      // else {
      // dispatch(setUserSkills(returnedData));
      // await checkPrimarySkill({
      //   updatedSkills: returnedData,
      //   setUserSkills: (value) => dispatch(setUserSkills(value)),
      // });
      // }
    }

    const userState = { user, setUser: (value) => dispatch(setUser(value)) };
    const statusState = {
      status: userStatus,
      setStatus: (value) => dispatch(setUserStatus(value)),
    };

    await checkProfileComplete(
      userState,
      statusState,
      returnedData,
      collaboratorsTypes
    );

    if (user.isProfileComplete) {
      const feedResponse = await generateFeeds(user);

      if (feedResponse === "User feed generated") {
        dispatch(setPage(1));
      }
    }

    dispatch(setUserSkills([]));
    dispatch(setIsButtonLoading(false));
    navigate(-1);
    recalculateScore();
  };

  const addSkill = async () => {
    dispatch(setIsButtonLoading(true));

    if (data?.startedTrainingAge && data?.startedTrainingAge < 10) {
      dispatch(
        updateInvalid({
          isInvalidOpen: true,
          message: "The started training age must be at least 10 years old.",
        })
      );
      dispatch(setIsButtonLoading(false));
      return;
    }

    const startedTrainingDate = getStartedTrainingDate();

    const targetCreatorType = data?.category;
    const targetImage = creatorDefaultImages[targetCreatorType];
    const original = targetImage;
    const cropp = targetImage;

    const isSkillComplete = checkSkillComplete({
      name: data?.name,
      description: data?.description,
      level: data?.level,
      startedTrainingDate,
    });

    const { data: returnedData, error } = await axios.post(
      `${node_server}/api/skills`,
      {
        userId: user.id,
        name: data?.name,
        level: data?.level,
        startedTrainingAge: data?.startedTrainingAge,
        startedTrainingDate,
        category: data?.category,
        speciality: data?.speciality,
        link: data?.link,
        description: data?.description,
        isPrimary: data?.isPrimary,
        acceptOnlyPaidProject: data?.acceptOnlyPaidProject,
        isCompleted: isSkillComplete,
        skillCoverImage: cropp,
        originalCoverImage: original,
      },
      {
        withCredentials: true,
      }
    );

    if (error) console.log(error);
    // if (returnedData) {
    // dispatch(setUserSkills(returnedData));
    // await checkPrimarySkill({
    //   updatedSkills: returnedData,
    //   setUserSkills: (value) => dispatch(setUserSkills(value)),
    // });
    // }

    const userState = { user, setUser: (value) => dispatch(setUser(value)) };
    const statusState = {
      status: userStatus,
      setStatus: (value) => dispatch(setUserStatus(value)),
    };

    await checkProfileComplete(
      userState,
      statusState,
      returnedData,
      collaboratorsTypes
    );

    if (user.isProfileComplete) {
      const feedResponse = await generateFeeds(user);

      if (feedResponse === "User feed generated") {
        dispatch(setPage(1));
      }
    }

    dispatch(setUserSkills([]));
    dispatch(setIsButtonLoading(false));
    navigate(-1);
    recalculateScore();
  };

  return { editSkill, addSkill };
};

export default useEditSkill;
